module.exports = __webpack_public_path__ + "static/media/culture.81f002b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/culture.svg
// module id = 369
// module chunks = 7